import config from '@/config'
import errorBorder from '@/helper/formValidation/errorBorder'
import { alert } from '@/plugins/notification'

export function formatFileSize (size) {
  const i = size === 0 ? 0 : Math.floor(Math.log(size) / Math.log(1024))
  return (size / Math.pow(1024, i)).toFixed(2) * 1 + ' ' + ['B', 'KB', 'MB', 'GB', 'TB'][i]
}

export function validateWorkflowBeforeProceed ({
  currentStatus,
  workflowData,
  selectedResource,
  selectedNextAction,
  closeWFTform,
  newFiles,
  existingFiles,
  nextStepData,
  wFstepUsers
}) {
  if (currentStatus === config.FORM_STATE_MAP.DRAFT) return false

  const workflowStage = workflowData?.workflow_stage
  let error = false

  const raiseError = (msg) => {
    alert(msg)
    error = true
  }

  // 1. Resource required
  if (workflowStage?.resource_group && !selectedResource?.id) {
    raiseError('Please select resource before proceeding')
  }

  // 2. Mandatory file upload (on_start)
  const trigger = workflowStage?.trigger_actions?.[0]
  if (
    trigger?.trigger_timing === 'on_start' &&
    trigger?.mandatory === true &&
    (selectedNextAction || closeWFTform)
  ) {
    const totalFiles = [...newFiles, ...existingFiles]
    if (!totalFiles.length) {
      raiseError('File upload mandatory before next action!')
    }
  }

  // 3. Wait for uploading files
  if (newFiles.some(f => f.status === 'uploading')) {
    raiseError('Please wait for all files to finish uploading before saving.')
  }

  // 4. Next step users validation
  if (
    selectedNextAction &&
    !nextStepData.core_user_group?.name &&
    !wFstepUsers?.length
  ) {
    errorBorder('multiSelectinput', true)
    raiseError('Please select users for the next step')
  }

  return error
}
